// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getUsuarios as listUsuariosAPI,
    getUsuario as getUsuarioAPI,
    addUsuario as addUsuarioAPI,
    updateUsuario as updateUsuarioAPI,
    updateUsuarioSelf as updateUsuarioSelfAPI,
    deleteUsuario as deleteUsuarioAPI
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { usersApiResponseError, usersApiResponseSuccess } from './actions';
import { UsersActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getUsuario({ payload: { id } }) {
    try {
        const response = yield call(getUsuarioAPI, id );
        const usuario = response.data.data;
        // NOTE - You can change this according to response format from your api
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(usersApiResponseSuccess(UsersActionTypes.GET_USER, usuario));
    } catch (error) {
        yield put(usersApiResponseError(UsersActionTypes.GET_USER, error));
        // api.setLoggedInUser(null);
        // setAuthorization(null);
    }
}

/**
 * List contactos
 */
function* listUsuarios({payload:params}) {
    try {
        const response = yield call(listUsuariosAPI, { ...params });
        const listaUsuarios = response.data.data;
        yield put(usersApiResponseSuccess(UsersActionTypes.LIST_USERS, listaUsuarios));
    } catch (error) {
        yield put(usersApiResponseError(UsersActionTypes.LIST_USERS, error));
    }
}

function* addUsuario({payload:usuario}){
    try{
        const response = yield call(addUsuarioAPI,{...usuario})
        const user = response.data.data
        yield put(usersApiResponseSuccess(UsersActionTypes.ADD_USER,user))
    }catch(error){
        yield put(usersApiResponseError(UsersActionTypes.ADD_USER,error))
    }
}

function* updateUsuario({payload:usuario}){
    try{
        const response = yield call(updateUsuarioAPI,{...usuario})
        const user = response.data.data
        yield put(usersApiResponseSuccess(UsersActionTypes.UPDATE_USER,user))
    }catch(error){
        yield put(usersApiResponseError(UsersActionTypes.UPDATE_USER,error))
    }
}

function* updateUsuarioSelf({payload:usuario}){
    try{
        const response = yield call(updateUsuarioSelfAPI,{...usuario})
        const user = response.data.data
        yield put(usersApiResponseSuccess(UsersActionTypes.UPDATE_USER_SELF,user))
    }catch(error){
        yield put(usersApiResponseError(UsersActionTypes.UPDATE_USER_SELF,error))
    }
}


function* deleteUsuario({payload:{id}}){
    try{
        const response = yield call(deleteUsuarioAPI,id)
        const user = response.data.id
        yield put(usersApiResponseSuccess(UsersActionTypes.DELETE_USER,user))
    }catch(error){
        yield put(usersApiResponseError(UsersActionTypes.DELETE_USER,error))
    }
}


export function* watchGetUsuario(): any {
    yield takeEvery(UsersActionTypes.GET_USER, getUsuario);
}

export function* watchListUsuarios(): any {
    yield takeEvery(UsersActionTypes.LIST_USERS, listUsuarios);
}

export function* watchAddUsuario():any{
    yield takeEvery(UsersActionTypes.ADD_USER, addUsuario);
}

export function* watchUpdateUsuario(): any{
    yield takeEvery(UsersActionTypes.UPDATE_USER, updateUsuario);
}

export function* watchUpdateUsuarioSelf(): any{
    yield takeEvery(UsersActionTypes.UPDATE_USER_SELF, updateUsuarioSelf);
}


export function* watchDeleteUsuario(): any{
    yield takeEvery(UsersActionTypes.DELETE_USER, deleteUsuario);
}


function* usersSaga(): any {
    yield all([
        fork(watchGetUsuario),
        fork(watchListUsuarios),
        fork(watchAddUsuario),
        fork(watchUpdateUsuario),
        fork(watchUpdateUsuarioSelf),
        fork(watchDeleteUsuario),
    ]);
}

export default usersSaga;
